import { useTranslation } from "react-i18next";

export default function DemoVideo() {
  const { t } = useTranslation();

  return (
    <section className="py-20 bg-white dark:bg-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center text-gray-900 dark:text-white mb-12">
          {t("demoVideo.title")}
        </h2>
        <div className="relative aspect-w-16 aspect-h-9 rounded-lg shadow-lg overflow-hidden max-w-md mx-auto">
          <video
            className="w-full h-full object-cover"
            controls
            playsInline
            poster="/images/video-thumbnail.jpg"
          >
            <source src="/cheesyGarlicBread.mp4" type="video/mp4" />
            {t("demoVideo.placeholder")}
          </video>
        </div>
      </div>
    </section>
  );
}
